module.exports = __webpack_public_path__ + "static/media/w2.c6b3743a.png";